import React, { useEffect } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeAddSubjectAdmin, openShowSubjectAdminDataModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { adminSelectStyles } from "../../../../components/Models/admin-modal-theme";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAdminSubjectRequest,
  editTeacherRequest,
} from "../../../../modules/admin-modules/teachers/Actions";
import { getAllGradesRequest } from "../../../../modules/admin-modules/grades/Actions";
import { getAllSubjectsRequest } from "../../../../modules/admin-modules/subjects/Actions";

const selectStyles = adminSelectStyles({ menuZIndex: 50 });

const AddSubjectAdmin = ({ isAdd, data, setSelectedData, setAddedSubjectAdmin }) => {
  const openTeacher = useSelector((state) => state.model.isOpen36);
  const dispatch = useDispatch();
  const grades = useSelector((state) => state.grades.grades);
  const isLoading = useSelector((state) => state.teachers.isLoading);

  const gradesOptions = grades?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    if (openTeacher) {
      dispatch(getAllGradesRequest());
      dispatch(getAllSubjectsRequest());
    }
  }, [openTeacher, dispatch]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box textAlign="left">
      <Heading color="var(--text-primary)" fontSize="24px">
        {isAdd ? "Add Subject" : "Edit Subject"}
      </Heading>
      <Text mt={2} fontSize="sm" color="var(--text-muted)">
        {isAdd ? "Create a new subject and assign a grade" : "Update subject details"}
      </Text>
    </Box>
  );

  const onSubmit = (data) => {
    const action = (responseData) => {
      dispatch(closeAddSubjectAdmin());
      setAddedSubjectAdmin && setAddedSubjectAdmin(responseData);
      dispatch(openShowSubjectAdminDataModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(createAdminSubjectRequest(formData, action));
    } else {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(
        editTeacherRequest({
          id: data?.id,
          formData: formData,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddSubjectAdmin());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTeacher}
      buttonTitle={isAdd ? "Add Subject" : "Edit Subject"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={8} spacingY={6} alignItems="start">
            <MainInput
              label="Subject name (English)"
              error={errors?.subject_name?.message}
              placeholder="Enter subject name in English"
              register={register}
              name="subject_name"
            />
            <MainInput
              label="Subject name (Arabic)"
              error={errors?.subject_name_ar?.message}
              placeholder="Enter subject name in Arabic"
              register={register}
              name="subject_name_ar"
            />
            <MainInput
              label="Phone number"
              error={errors?.phone?.message}
              placeholder="Enter phone number"
              register={register}
              name="phone"
            />
            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color="var(--text-primary)"
                  textAlign="left"
                >
                  Grade
                </FormLabel>
                <Select
                  options={gradesOptions}
                  onChange={(data) => setValue("grade_id", data.value)}
                  styles={selectStyles}
                  placeholder="Select grade"
                />
              </VStack>
            </FormControl>
          </SimpleGrid>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddSubjectAdmin;
